const TOKEN_KEY = 'dgr_jwt';
const SESSION_USER = 'dgr_SESSION_USER';

export const setSession = (token) => {
    localStorage.setItem(TOKEN_KEY,token);
}

export const setUserSession = (user) => {
    localStorage.setItem(SESSION_USER,JSON.stringify(user));
}

export const ripSession = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SESSION_USER);
}

export const getSession = () => {
    return localStorage.getItem(TOKEN_KEY);
}

export const getUserSession = () => {
    return JSON.parse(localStorage.getItem(SESSION_USER));
}

export const isSession = () => {
    if (localStorage.getItem(TOKEN_KEY)) {
        return true;
    }

    return false;
}